<script setup lang="ts">
  import { ref, defineProps } from 'vue'
  import { Button } from '@/components/ui/button'
  import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip'
  import { CopyIcon, CheckIcon } from 'lucide-vue-next'
  import { TableCell } from '@/components/ui/table'

  const props = defineProps({
    truncate: {
      type: Boolean,
      default: true
    },
    noCopy: {
      type: Boolean,
      default: false
    }
  })

  const contentRef = ref<HTMLElement | null>(null)
  const isCopied = ref(false)

  const copyToClipboard = async () => {
    if (contentRef.value) {
      try {
        await navigator.clipboard.writeText(contentRef.value.textContent || '')
        isCopied.value = true
        setTimeout(() => {
          isCopied.value = false
        }, 2000)
      } catch (err) {
        console.error('Failed to copy text: ', err)
      }
    }
  }
</script>

<template>
  <TableCell :class="['group px-5 py-4', truncate ? 'max-w-0' : 'w-1/3']">
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger class="flex w-full items-center">
          <p
            ref="contentRef"
            :class="['text-sm font-bold text-gray-700', truncate ? 'truncate' : '']"
          >
            <slot></slot>
          </p>
          <Button
            v-if="!noCopy"
            variant="ghost"
            size="icon"
            @click="copyToClipboard"
          >
            <CopyIcon
              v-if="!isCopied"
              class="h-4 w-4"
            />
            <span
              v-else
              class="text-xs"
            >
              <CheckIcon class="h-4 w-4 text-green-500" />
            </span>
          </Button>
        </TooltipTrigger>
        <TooltipContent align="start">
          <slot></slot>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  </TableCell>
</template>

<style scoped></style>
